var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pending-products',{attrs:{"model":_vm.model,"schema":_vm.schema,"headers":_vm.headers,"details_headers":_vm.details_headers}})}
var staticRenderFns = []

export { render, staticRenderFns }